import TextInput from 'components/Common/Form/Input/TextInput'
import { useAppSelector } from 'hooks/reduxHooks'
import React from 'react'

interface Props {
  name: string
  defaultValue?: Tours.TailorMadeTourRequest['contactLastName']
}

function TailorMadeTourLastNameInput({ name, defaultValue }: Props) {
  const lastName = useAppSelector(state => state.auth.account.surname)

  return <TextInput
    label="Last name"
    autoComplete="family-name"
    required
    defaultValue={defaultValue ?? lastName}
    name={name}
  />
}

export default TailorMadeTourLastNameInput
